import { createApp } from 'vue'
import App from './App.vue'
import GCash from "./GCash";

//createApp(GCash).mount('#payment')

const apps = {
    bank: App,
    gcash: GCash
}

window.renderApp = (name, el = "#payment") => {
    createApp(apps[name]).mount(el)
}